import { STATIC_STRINGS } from "@asez/shared";
import defaultImg from "../../../../assets/default-img.jpg";

function Sidebar({ report }) {
  const imageUrl = report.photoUrl || defaultImg;
  
  return (
    <div>
      <div className="bg-gray-50 py-3 px-4 rounded-lg flex flex-col items-center">
        <img
          src={imageUrl}
          alt="Candidate"
          className="h-32 w-32 object-cover border-2 border-gray-300 mb-3"
        />
        <h4>{STATIC_STRINGS.OVERALL_REPORT_ENUM.CANDIDATE_NAME}</h4>
        <h1 className="text-xl font-bold mb-2">{report.name}</h1>
        <h4>{STATIC_STRINGS.OVERALL_REPORT_ENUM.CANDIDATE_PH_NUMBER}</h4>
        <p className="text-gray-600 text-xl font-bold mb-2">{report.phoneNumber}</p>
        <h4>{STATIC_STRINGS.OVERALL_REPORT_ENUM.CANDIDATE_EMAIL}</h4>
        <p className="text-gray-600 text-xl font-bold mb-2">{report.email}</p>
        <h4>{STATIC_STRINGS.OVERALL_REPORT_ENUM.CANDIDATE_PROFILES}</h4>
        {
          report.socialMediaLinks?.map((obj) => {
            return (
              <a 
                href={obj.link} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline mb-2" key={obj.type}
              >
                {obj.type}
              </a>
            )
          })
        }
        <h4>{STATIC_STRINGS.OVERALL_REPORT_ENUM.CANDIDATE_RESUME}</h4>
        <a 
          href={report.resume} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline"
        >
          {STATIC_STRINGS.OVERALL_REPORT_ENUM.DOWNLOAD_RESUME}
        </a>
      </div>
    </div>
  );
}

export default Sidebar;